import Link from "next/link";
import FooterLogo from "./footerLogo";

const Footer_Logo_Description = ({footerFirstSection, mediaBaseUrl, footerFirstSectionIcons, socialIcons}) =>{
    return(
        <div className="flex-none w-full lg:w-[29%] *:mb-4 *:lg:mb-[2vw] font-normal">
              {footerFirstSection && mediaBaseUrl && <FooterLogo mediaBaseUrl={mediaBaseUrl} footerFirstSection={footerFirstSection} />}

              {footerFirstSection?.description && <div
                dangerouslySetInnerHTML={{
                  __html: footerFirstSection.description,
                }}
              ></div>}

              <ul className="flex gap-x-8 lg:gap-x-[2vw] mt-8 lg:mt-[3vw] !mb-0">
  {footerFirstSectionIcons &&
    Object.entries(socialIcons).map(([key, { svg }]) =>
      footerFirstSectionIcons[key] ? (
        <li key={key}>
          <Link
            href={footerFirstSectionIcons[key]}
            target="_blank"
            className="*:fill-[#DBDBDB] *:w-5 *:h-5 *:lg:w-[1.3vw] *:lg:h-[1.3vw]"
          >
            {svg}
          </Link>
        </li>
      ) : null
    )}
</ul>
            </div>
    )
}

export default Footer_Logo_Description;